export default __webpack_public_path__ + "static/unicorn-lego-man--mobile-7a496d5ba2d4da7d78fd8eee3dd692cb.jpg";